<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

import { RouterLink } from 'vue-router';

export interface Props {
  title?: string;
  subtitle?: string;
  icon?: string;
  to?: RouteLocationRaw;
  disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  title: 'Page',
  subtitle: '',
  icon: 'mdi-home',
  to: undefined,
  disabled: false,
});
</script>

<template>
  <component
    :is="!props.disabled && props.to ? RouterLink : 'div'"
    :to="!props.disabled && props.to ? props.to : undefined"
    :class="[$style.jobBookingPageCard, props.disabled && $style.disabled]"
    data-testid="jobBookingPageCard"
  >
    <div :class="$style.iconWrapper">
      <v-icon :icon="props.icon" :class="$style.icon" size="20" />
    </div>
    <span :class="$style.title">{{ props.title }}</span>
    <span :class="$style.subtitle">{{ props.subtitle }}</span>
  </component>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/brand-primary' as bp;

.jobBookingPageCard {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.25rem;
  text-decoration: none;
  color: colors.$color-text-primary;
  border: 1px solid colors.$color-gray-200;
  border-radius: 8px;
  background-color: colors.$color-white;
  transition: box-shadow 0.15s ease;
  &:not(.disabled):hover {
    box-shadow: 0 2px 8px colors.$color-shadow-black-10;
  }
  &.disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}
  .iconWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background-color: colors.$color-gray-100;
    margin-bottom: 0.5rem;
  }
  .icon {
    color: bp.$color-brand-600;
  }
  .title {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.2;
  }
  .subtitle {
    font-size: 0.8125rem;
    color: colors.$color-text-tertiary;
    line-height: 1.4;
  }
</style>
